import { render, staticRenderFns } from "./tabbed-nav.vue?vue&type=template&id=8badb6b2&scoped=true&"
import script from "./tabbed-nav.vue?vue&type=script&lang=js&"
export * from "./tabbed-nav.vue?vue&type=script&lang=js&"
import style0 from "./tabbed-nav.vue?vue&type=style&index=0&id=8badb6b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8badb6b2",
  null
  
)

export default component.exports